import { NotificationConfiguration } from '../notification.templates';

export const RACI_REPORT_OVERDUE_REMINDER: NotificationConfiguration = {
  inapp: `A report is overdue.`,
  email: {
    ctaKey: 'check_in_report',
  },
};
